import { ExposureHighlight } from '@/store/modules/walkthrough/types/outcomes/resultOverview/highlights/exposureHighlight'

export interface ExposureData {
  have: boolean;
  haveSymptoms: boolean;
}

export class Exposure implements ExposureData {
  // eslint-disable-next-line no-useless-constructor
  constructor (
    public have: boolean,
    public haveSymptoms: boolean
  ) {}

  public set (property: keyof ExposureData, value: boolean): void {
    this[property] = value
  }

  public selected (): Array<keyof ExposureData> {
    const result = new Array<keyof ExposureData>()

    this.addIfSelected('have', result)
    this.addIfSelected('haveSymptoms', result)

    return result
  }

  private addIfSelected (typeOfExposure: keyof ExposureData, selected: Array<keyof ExposureData>): void {
    if (!this[typeOfExposure]) {
      return
    }

    selected.push(typeOfExposure)
  }

  public static empty (): Exposure {
    return new Exposure(false, false)
  }

  public any (): boolean {
    return this.have || this.haveSymptoms
  }

  public none (): boolean {
    return !this.any()
  }
}
